import React, { useState, useEffect, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  Dialog,
  Typography,
  Slide,
  CircularProgress,
  Box,
  TextField,
  MenuItem,
  Paper,
  Tooltip,
  IconButton,
} from "@mui/material";

import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2

import { apiGet, API } from "@services/API";
import ImageListViewer from "@components/ImageListViewer";

import { useSnackbar } from "notistack";
import moment from "moment";
import CollectionsIcon from "@mui/icons-material/Collections";
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function headers() {
  let headers = {};
  let token = localStorage.getItem("covid19_token");
  let mfa_token = localStorage.getItem("mfa_token");
  if (token && token.length > 0 && mfa_token && mfa_token.length > 0) {
    headers = { "x-access-token": token };
  }
  return headers;
}

export default function PatientNotesDialog({
  isVisible,
  onClose,
  onSave,
  patientID,
  ...props
}) {
  let history = useHistory();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true);

  const [dataNotes, setDataNotes] = useState(null);
  const [dataMedia, setDataMedia] = useState(null);
  const [isViewImageListVisible, setIsViewImageListVisible] = useState(false);

  const [dataSelectedMedia, setDataSelectedMedia] = useState([]);

  const [isAddNoteDialogVisible, setAddNoteDialogVisible] = useState(false);
  const [noteTitle, setNoteTitle] = useState("");
  const [noteText, setNoteText] = useState("");
  const [remainingCharacters, setRemainingCharacters] = useState(2500);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const timeOut = setTimeout(() => {
      if (patientID !== null) {
        apiGet(
          `/listmedia/${patientID}/${undefined}`,
          { headers: headers() },
          history
        )
          .then((response) => {
            if (!isNullOrEmpty(response.data.result)) {
              setDataMedia(response.data.result);
            } else {
              setDataMedia(null);
            }
          })
          .catch((error) => {
            setDataMedia(null);
          });

        apiGet(`/notes/${patientID}`, { headers: headers() }, history)
          .then((response) => {
            if (!isNullOrEmpty(response.data)) {
              const sortedData = response.data.sort(
                (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
              );
              setDataNotes(sortedData);
            } else {
              setDataNotes(null);
            }
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            setDataNotes(null);
          });
      } else {
        setLoading(false);
        setDataNotes(null);
        setDataMedia(null);
      }
    }, 200);

    return () => clearTimeout(timeOut);
  };

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography data-test={"snack-title"} variant="h6">
          {title}
        </Typography>
        <Typography data-test={"snack-text"} variant="subtitle1">
          {subtitle}
        </Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const handleClose = () => {
    onClose();
  };

  const getNoteTitle = (item) => {
    switch (item.level) {
      case 1:
        return (
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              backgroundColor: "#3366cc",
              display: "flex",
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              padding: 0,
            }}
          >
            <Grid item xs={4} style={{ textAlign: "start" }}>
              <Typography>{item.author}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Typography>Governing Doctor Note</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={{ textAlign: "end" }}>
                {moment(item.timestamp).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Grid>
          </Grid>
        );
      case 2:
        return (
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              backgroundColor: "#dc3912",
              display: "flex",
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              padding: 0,
            }}
          >
            <Grid item xs={4} style={{ textAlign: "start" }}>
              <Typography>{item.author}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Typography>Governing Nurse Note</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={{ textAlign: "end" }}>
                {moment(item.timestamp).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Grid>
          </Grid>
        );
      case 3:
        return (
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              backgroundColor: "#ff9900",
              display: "flex",
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              padding: 0,
            }}
          >
            <Grid item xs={4} style={{ textAlign: "start" }}>
              <Typography>{item.author}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Typography>HSE Admin Note</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={{ textAlign: "end" }}>
                {moment(item.timestamp).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Grid>
          </Grid>
        );
      case 5:
        return (
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              backgroundColor: "#109618",
              display: "flex",
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              padding: 0,
            }}
          >
            <Grid item xs={4} style={{ textAlign: "start" }}>
              <Typography>{item.author}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Typography>Doctor Note</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={{ textAlign: "end" }}>
                {moment(item.timestamp).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Grid>
          </Grid>
        );
      case 6:
        return (
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              backgroundColor: "#990099",
              display: "flex",
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              padding: 0,
            }}
          >
            <Grid item xs={4} style={{ textAlign: "start" }}>
              <Typography>{item.author}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Typography>Admin Nurse Note</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={{ textAlign: "end" }}>
                {moment(item.timestamp).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Grid>
          </Grid>
        );
      case 7:
        return (
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              backgroundColor: "#0099c6",
              display: "flex",
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              padding: 0,
            }}
          >
            <Grid item xs={4} style={{ textAlign: "start" }}>
              <Typography>{item.author}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Typography>Nurse Note</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={{ textAlign: "end" }}>
                {moment(item.timestamp).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Grid>
          </Grid>
        );
      case 8:
        return (
          <Grid
            item
            xs={12}
            style={{
              color: "white",
              backgroundColor: "#dd4477",
              display: "flex",
              borderTopLeftRadius: 4,
              borderTopRightRadius: 4,
              padding: 0,
            }}
          >
            <Grid item xs={4} style={{ textAlign: "start" }}>
              <Typography>{item.author}</Typography>
            </Grid>
            <Grid item xs={4} style={{ textAlign: "center" }}>
              <Typography>Carer Note</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={{ textAlign: "end" }}>
                {moment(item.timestamp).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Grid>
          </Grid>
        );
      default:
        return <Typography style={{}}></Typography>;
    }
  };

  const mediaIdsForNote = (mediaArray) => {
    if (
      mediaArray !== undefined &&
      mediaArray !== null &&
      mediaArray.length > 0
    ) {
      return mediaArray.map((media) => media.media_id);
    } else {
      return [];
    }
  };

  const getMediaForNote = (item) => {
    if (dataMedia !== undefined && dataMedia !== null && dataMedia.length > 0) {
      const mediaIds = mediaIdsForNote(item.media);
      return dataMedia.filter((media) => mediaIds.includes(media.id));
    } else {
      return [];
    }
  };

  const showImageViewDialog = (selectedMediaList) => {
    const filteredMedia = getMediaForNote(selectedMediaList);
    setDataSelectedMedia(filteredMedia);
    setIsViewImageListVisible(true);
  };

  const hideImageViewDialog = () => {
    setDataSelectedMedia([]);
    setIsViewImageListVisible(false);
  };

  const handleNoteTitleChange = (event) => {
    setNoteTitle(event.target.value);
  };

  const handleNoteTextChange = (event) => {
    const newText = event.target.value;
    const truncatedText = newText.slice(0, 2500); // Truncate to 2500 characters
    setNoteText(truncatedText);
    setRemainingCharacters(2500 - truncatedText.length);
  };

  const openAddNoteDialog = () => {
    setAddNoteDialogVisible(true);
  };

  const closeAddNoteDialog = () => {
    setAddNoteDialogVisible(false);
    setNoteTitle("");
    setNoteText("");
    setRemainingCharacters(2500);
  };

  const handleAddNote = () => {
    if (isNullOrEmpty(noteTitle)) {
      showSnackBar("error", "Failure", "Note title can't be empty.");
    } else if (isNullOrEmpty(noteText)) {
      showSnackBar("error", "Failure", "Note text can't be empty.");
    } else if (noteText.length > 2500) {
      showSnackBar(
        "error",
        "Failure",
        "Note text exceeds 2500 characters limit."
      );
    } else {
      let message = {
        UserId: Number(localStorage.getItem("user_id")),
        PatientId: patientID,
        Level: Number(localStorage.getItem("user_level")),
        Author: localStorage.getItem("full_name"),
        Title: noteTitle,
        Log: noteText,
        selectedMediaList: [],
        timestamp: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      };

      API.post("/note", message, {
        headers: headers(),
      })
        .then((response) => {
          showSnackBar(
            "success",
            "Success",
            "Successfully saved note details."
          );

          setNoteTitle("");
          setNoteText("");
          setRemainingCharacters(2500);
          setAddNoteDialogVisible(false);

          fetchData();
        })
        .catch((error) => {
          showSnackBar("error", "Failure", "Failed to save note details.");
        });
    }
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        open={isVisible}
        onClose={handleClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            backgroundColor: "#FFF",
            boxShadow: "none",
          },
        }}
      >
        <Box
          style={{
            //display: "flex",
            justifyContent: "center",
            margin: 15,
          }}
        >
          {loading ? (
            <CircularProgress color="primary" />
          ) : (
            <>
              <Grid
                container
                spacing={2}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography data-test={"patient-notes-title"} variant="h6">
                    Notes
                  </Typography>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid
                    container
                    spacing={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      //flexDirection: "column",
                    }}
                  >
                    {dataNotes !== null && dataNotes.length > 0 ? (
                      <>
                        {dataNotes.map((item) => (
                          <Paper
                            key={item.note_id}
                            elevation={2}
                            style={{
                              margin: 8,
                              width: "calc(100% - 16px)",
                            }}
                          >
                            {getNoteTitle(item)}

                            <Grid item xs={12}>
                              {item.media.length > 0 && (
                                <Tooltip title="Images">
                                  <IconButton
                                    aria-label="images"
                                    size="small"
                                    color="primary"
                                    style={{ position: "absolute", right: 20 }}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      showImageViewDialog(item);
                                    }}
                                  >
                                    <CollectionsIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>
                              )}

                              <Typography
                                data-test={"patient-notes-note-title"}
                                style={{ fontWeight: "bold" }}
                              >
                                {item.title}
                              </Typography>
                              <Typography data-test={"patient-notes-note-log"}>
                                {item.log}
                              </Typography>
                            </Grid>
                          </Paper>
                        ))}
                      </>
                    ) : (
                      dataNotes === null && (
                        <Typography
                          data-test={"patient-notes-empty-msg"}
                          style={{ textAlign: "center", padding: 20 }}
                        >
                          There is no data available.
                        </Typography>
                      )
                    )}
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                  }}
                >
                  <Button
                    data-test={"patient-notes-add-note-btn"}
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10 }}
                    onClick={openAddNoteDialog}
                  >
                    Add Note
                  </Button>
                  <Button
                    data-test={"patient-notes-add-cancel-btn"}
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: 10 }}
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={isAddNoteDialogVisible}
        onClose={() => setAddNoteDialogVisible(false)}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            backgroundColor: "#FFF",
            boxShadow: "none",
          },
        }}
      >
        <Box style={{ margin: 15 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                data-test={"patient-notes-add-note-main-title"}
                variant="h6"
                style={{ textAlign: "center" }}
              >
                Note
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                data-test={"patient-notes-add-note-title"}
                label="Title"
                variant="outlined"
                size="small"
                fullWidth
                value={noteTitle}
                onChange={handleNoteTitleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                data-test={"patient-notes-add-note-note"}
                label="Note"
                variant="outlined"
                size="small"
                multiline
                fullWidth
                rows={6}
                value={noteText}
                onChange={handleNoteTextChange}
              />
              <Typography
                data-test={"patient-notes-add-note-remaining-characters"}
                variant="caption"
                color="textSecondary"
              >
                Remaining characters: {remainingCharacters}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "end" }}
            >
              <Button
                data-test={"patient-notes-add-note-cancel-btn"}
                variant="contained"
                color="primary"
                style={{ marginLeft: 10 }}
                onClick={closeAddNoteDialog}
              >
                Cancel
              </Button>
              <Button
                data-test={"patient-notes-add-note-save-btn"}
                variant="contained"
                color="primary"
                style={{ marginLeft: 10 }}
                onClick={handleAddNote}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
      {isViewImageListVisible && (
        <ImageListViewer
          data={dataSelectedMedia}
          open={isViewImageListVisible}
          onClose={hideImageViewDialog}
        />
      )}
    </>
  );
}
